import { FC } from 'react';
import { IndicatorsContainerProps } from 'react-select';
import styled from 'styled-components';

const IndicatorsContainer: FC<IndicatorsContainerProps> = ({
  children,
  cx,
  ...props
}) => {
  return <Root {...props}>{children}</Root>;
};

export default IndicatorsContainer;

const Root = styled.div`
  align-items: center;
  display: flex;
  margin-left: auto;
`;
